// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedContactModels {
    static getAttributeTypeMap() {
        return SiteSharedContactModels.attributeTypeMap;
    }
}
SiteSharedContactModels.discriminator = undefined;
SiteSharedContactModels.additionalProperties = false;
SiteSharedContactModels.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<SiteSharedContactModel>"
    },
];
//# sourceMappingURL=siteSharedContactModels.js.map